import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

const routerConfig = {
  mode: 'history',
  // linkActiveClass: 'active',
  routes
}

const router = new Router(routerConfig)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js